import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=1a366854&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=ts"
export * from "./UploadImage.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./UploadImage.vue?vue&type=style&index=0&id=1a366854&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1a366854",
  "d9c5149c"
  
)

export default component.exports